function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.653 15.234v-3.907c0-3.897-2.314-7.245-5.784-8.6C14.52 1.168 13.14 0 11.5 0 9.858 0 8.48 1.168 8.13 2.728c-3.47 1.354-5.783 4.702-5.783 8.6v3.906L.285 17.342A1 1 0 000 18.04v2.977a.97.97 0 00.972.968H7.46C7.465 24.125 9.35 26 11.5 26c2.15 0 4.035-1.875 4.04-4.015h6.488a.97.97 0 00.972-.968V18.04a1 1 0 00-.285-.698l-2.062-2.108zm-9.153 8.83c-1.15 0-2.09-1.08-2.095-2.08h4.19c-.006 1-.946 2.08-2.095 2.08zm9.555-4.016H1.945V18.42l2.347-2.398v-4.695c0-3.53 2.346-6.432 5.7-7.138V3.5c0-.835.67-1.565 1.508-1.565s1.508.73 1.508 1.565v.687c3.353.705 5.7 3.606 5.7 7.137v4.695l2.346 2.4v1.626z",
  fill: "inherit",
  fillRule: "evenodd"
});

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFF"
  }, props), _ref);
}

export default SvgBell;